import { render, staticRenderFns } from "./ot-claim-layout.vue?vue&type=template&id=2dda9c27&scoped=true&"
import script from "./ot-claim-layout.vue?vue&type=script&lang=ts&"
export * from "./ot-claim-layout.vue?vue&type=script&lang=ts&"
import style0 from "./ot-claim-layout.vue?vue&type=style&index=0&id=2dda9c27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dda9c27",
  null
  
)

export default component.exports